import React, { useEffect, useState, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import logo2 from "../images/logo5.jpg";
import notificationSound from "../assets/new.notification.mp3.mp3";
import axios from "axios";
import { API } from "../utils/apk";

function Navbar({ stopNotificationSoundRef }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [orders, setOrders] = useState([]);
  const [highlightOrdersTab, setHighlightOrdersTab] = useState(false);
  const [logoUrl, setLogoUrl] = useState(null);
  const audioRef = useRef(null);
  const location = useLocation();
  const prevOrderIdsRef = useRef([]);
  const hasInitializedRef = useRef(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  useEffect(() => {
    audioRef.current = new Audio(notificationSound);
    audioRef.current.load();
  }, []);

  const playSound = () => {
    if (audioRef.current) {
      audioRef.current.play().catch((e) => {
        console.warn("Audio play blocked by browser:", e);
      });
    }
  };

  const stopSound = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };

  if (stopNotificationSoundRef) {
    stopNotificationSoundRef.current = stopSound;
  }

  const showDesktopNotification = (title, body) => {
    if ("Notification" in window && Notification.permission === "granted") {
      new Notification(title, { body });
    }
  };

  const fetchOrders = async () => {
    try {
      const response = await axios.get(`${API}/get/all/order`);
      const newOrders = response.data.data || [];
      const newOrderIds = newOrders.map((o) => o._id);

      if (hasInitializedRef.current) {
        const newOnes = newOrderIds.filter(
          (id) => !prevOrderIdsRef.current.includes(id)
        );

        if (newOnes.length > 0 && location.pathname !== "/Orders") {
          playSound();
          setHighlightOrdersTab(true);

          if (document.hidden || !document.hasFocus()) {
            showDesktopNotification(
              "🛒 New Order Received",
              "Check the Orders tab."
            );
          }
        }
      } else {
        hasInitializedRef.current = true;
      }

      prevOrderIdsRef.current = newOrderIds;
      setOrders(newOrders);
    } catch (err) {
      console.error("❌ Error fetching orders", err);
    }
  };

  useEffect(() => {
    if ("Notification" in window && Notification.permission !== "granted") {
      Notification.requestPermission();
    }

    fetchOrders();
    const interval = setInterval(fetchOrders, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (location.pathname === "/Orders") {
      setHighlightOrdersTab(false);
      stopSound();
    }
  }, [location.pathname]);

  useEffect(() => {
    const adminId = localStorage.getItem("adminId");
    if (!adminId) return;

    const fetchLogo = async () => {
      try {
        const res = await axios.get(`${API}/get/all/business`);
        const image = res?.data?.data?.[0]?.image;
        if (image) setLogoUrl(image);
      } catch (err) {
        console.error("Error fetching logo image:", err);
      }
    };

    fetchLogo();
  }, []);

  return (
    <nav className="bg-blue-900 w-full">
      {/* Top Marquee */}
      <div className="bg-blue-900 overflow-hidden whitespace-nowrap">
        <p className="text-white font-medium animate-marquee">
          Developed by - TDR Software Pvt Ltd .. Contact No - 9830657184
        </p>
      </div>

      {/* Main Navbar */}
      <div className="flex items-center justify-between px-2">
        {/* Left Logo */}
        <div>
          {logoUrl && (
            <img
              src={logoUrl}
              alt="Business Logo"
              className="h-14 w-14 rounded-full object-cover border-2 border-red-500 shadow"
            />
          )}
        </div>

        {/* Toggle Button (Mobile) */}
        <button
          className="text-white md:hidden focus:outline-none"
          onClick={toggleMenu}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16m-7 6h7"}
            />
          </svg>
        </button>

        {/* Links and Right Logo */}
        <div
          className={`${isMenuOpen ? "block" : "hidden"
            } md:flex md:items-center md:space-x-4 md:static absolute top-0 left-0 w-full bg-blue-900 md:bg-transparent md:w-auto z-50 px-0 md:px-0`}
        >
          <ul className="flex flex-col md:flex-row md:space-x-4 space-y-1 md:space-y-0 items-center">
            {[
              { to: "/", label: "DashBoard" },
              { to: "/register", label: "Register" },
              { to: "/offer", label: "Offer" },
              { to: "/Orders", label: "Orders", special: true },
              { to: "/add-business", label: "Business" },
              { to: "/Assigned", label: "Assigned" },
              { to: "/Confirmed", label: "Delivered" },
              { to: "/addDeliveryBoy", label: "Add Delivery Boy" },
              { to: "/mapDeliveryBoy", label: "Track Delivery" },
              { to: "/report", label: "Report" },
              { to: "/logout", label: "Logout" },
            ].map(({ to, label, special }) => (
              <li key={to}>
                <NavLink
                  to={to}
                  className={({ isActive }) =>
                    `px-5 rounded-md font-bold border-2 text-sm whitespace-nowrap ${isActive
                      ? "text-green-400 border-green-400"
                      : special && highlightOrdersTab
                        ? "text-red-500 border-red-500 animate-pulse"
                        : "text-white hover:text-red-400 border-transparent"
                    }`
                  }
                >
                  {label}
                </NavLink>
              </li>
            ))}

            {/* Right Logo */}
            <li>
              <img
                src={logo2}
                alt="Logo2"
                className="h-14 w-14 rounded-full object-cover border-2 border-red-500 shadow  "
              />
            </li>
          </ul>
        </div>
      </div>
    </nav>

  );
}

export default Navbar;
